'use strict';

var { grecaptchaGenerateToken } = require('../common/grecaptchaUtils');

/**
 * Initializes date picker
 * @param {string} containers - Container selector
 */
function initializeDatePicker(containers) {
    const $container = $(containers);
    const $input = $container.find('input');
    const $icon = $container.find('.calender-icon');
    const $datePickerWrapper = $container.find('.date-picker-wrapper');
    const orientation = $container.hasClass('birthday-container') ? 'auto bottom' : 'auto top';

    if (!$input.hasClass('datepicker-initialized')) {
        const existingVal = $input.val();
        const highlightToday = $input.val() === '';

        $input
            .datepicker({
                language: 'en',
                format: 'dd.mm.yyyy',
                container: $datePickerWrapper,
                endDate: 'future',
                orientation,
                autoclose: true,
                todayHighlight: highlightToday
            })
            .addClass('datepicker-initialized')
            .on('changeDate', () => {
                $input.parent().toggleClass('focus-active', true);
                if ($input.val() && $input.val() !== '') {
                    $('#form-dob-error').addClass('d-none').removeClass('d-block');
                    $input.closest('.py-form-field').removeClass('error-class');
                    $input.addClass('has-value');
                }
            });

        if (existingVal) {
            $input.datepicker('update', existingVal);
        }
    }

    $input.on('focus', () => {
        $input.datepicker('show');
    });

    $icon.on('click', () => {
        $input.focus();
    });
}
initializeDatePicker('.birthday-container');

/**
 * @param {*} $form form-container data
 */
function resetFormUI($form) {
    $form.find('input, select, textarea').each(function () {
        $(this).removeClass('has-value is-invalid');
    });
    $form.find('.py-custom-select-input').val('');
    $form.find('.py-option-value').removeClass('selected');
}

$(document).on('click', '.py-option-value.applying-for-option', function () {
    $('.c-applying-for-input').addClass('has-value');
    if ($('.c-applying-for-input').hasClass('is-invalid')) {
        $('.c-applying-for-input').removeClass('is-invalid');
        $('.applying-for-invalid-feedback').removeClass('d-block');
        $('.referredby-field').removeClass('applying-error');
    }
});

// form Submission
$('.career-form-submit').on('click', async function (e) {
    var $form = $('.career-form');
    e.preventDefault();

    let isValid = true;
    $form.find('input[required], select[required], textarea[required]').each(function () {
        let $field = $(this);
        let value = $field.val().trim();
        if (!value) {
            $field.addClass('is-invalid');
            isValid = false;
        } else {
            $field.removeClass('is-invalid');
        }

        if ($field.is('.c-applying-for-input') && $field.hasClass('is-invalid')) {
            $('.applying-for-invalid-feedback').addClass('d-block');
            $('.referredby-field').addClass('applying-error');
        }
    });

    if (!isValid) {
        if ($('#personaldetails').find('.is-invalid').length > 0) {
            $('#personaldetails').collapse('show');

            $('html, body').animate({
                scrollTop: $('.personal-details-container').offset().top - 100
            }, 500);
        }
        return;
    }

    const serializedData = $form.serialize() + '&recaptchaToken=' + await grecaptchaGenerateToken();
    $.spinner().start();
    $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        dataType: 'json',
        data: serializedData,
        success: (response) => {
            if (response.success) {
                $('body').trigger('successToast', response.message || 'Form submitted successfully!');
                $form[0].reset();
                resetFormUI($form);
            } else {
                $('body').trigger('errorToast', response.message || 'Something went wrong!');
            }
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
});

// Name field validation
$(document).on('input', '.c-fullname, .c-relative, .c-previousjob-mgr, .c-currentjob-mgr, .c-referredby', function () {
    let value = $(this).val();
    value = value.replace(/[^a-zA-Z\s]/g, '');
    value = value.replace(/^\s+/, '');
    let parts = value.split(' ');
    if (parts.length > 2) {
        value = parts[0] + ' ' + parts[1];
    }
    $(this).val(value);

    if ($(this).hasClass('is-invalid') && $(this).val().length > 3) {
        $(this).removeClass('is-invalid');
    }
});

// No space field validation
$(document).on('input', '.c-birthplace, .c-nationality, .c-mothertongue', function () {
    let value = $(this).val();
    value = value.replace(/[^a-zA-Z]/g, '');
    $(this).val(value);
    if ($(this).hasClass('is-invalid') && $(this).val().length > 3) {
        $(this).removeClass('is-invalid');
    }
});

// Mobile number field validation
$(document).on('input', '.c-mobileno, .c-currentjob-mgrno, .c-previousjob-mgrno', function () {
    let value = $(this).val();
    value = value.replace(/\D/g, '');
    if (value.length > 0 && !/^[6-9]/.test(value)) {
        value = value.substring(1);
    }
    value = value.substring(0, 10);
    $(this).val(value);

    if ($(this).hasClass('is-invalid') && $(this).val().length === 10) {
        $(this).removeClass('is-invalid');
    }
});

// Email input validation
$(document).on('input', '.c-email', function () {
    let value = $(this).val();
    value = value.toLowerCase();
    value = value.replace(/\s/g, '');
    value = value.replace(/[^a-z0-9@._%+-]/g, '');
    let parts = value.split('@');
    if (parts.length > 2) {
        value = parts[0] + '@' + parts[1];
    }
    $(this).val(value);

    if ($(this).hasClass('is-invalid') && $(this).val().length > 3) {
        $(this).removeClass('is-invalid');
    }
});

// Multple text and multi space validation
$(document).on('input', '.multitext', function () {
    let value = $(this).val();
    value = value.replace(/[^a-zA-Z0-9,.'#/\s-]/g, '');
    value = value.replace(/^\s+/, '');
    value = value.replace(/\s{2,}/g, ' ');
    $(this).val(value);

    if ($(this).hasClass('is-invalid') && $(this).val().length > 3) {
        $(this).removeClass('is-invalid');
    }
});

// Salary and employment year validation
$(document).on('input', '.numeric', function () {
    this.value = this.value.replace(/[^0-9]/g, '');
});

$('body').on('keyup change input', '.birthday-field', function () {
    const $this = $(this);
    const inputDate = $this.val();
    const updatedDate = inputDate.replace(/[^0-9.]/g, '');
    if (updatedDate.length >= 10) {
        $this.val(updatedDate.substring(0, 10));
    }

    if (inputDate && inputDate.trim() !== '') {
        $this.addClass('has-value');

        const datePattern = /^\d{2}\.\d{2}\.\d{4}$/;
        if (datePattern.test(inputDate)) {
            const dateParts = inputDate.split('.');
            const day = Number.parseInt(dateParts[0], 10);
            const month = Number.parseInt(dateParts[1], 10);
            const year = Number.parseInt(dateParts[2], 10);
            const testDate = new Date(year, month - 1, day);
            if (testDate.getDate() === day && testDate.getMonth() === month - 1 && testDate.getFullYear() === year) {
                $('#form-dob-error').addClass('d-none').removeClass('d-block');
                $this.closest('.py-form-field').removeClass('error-class');
            }
        }
    } else {
        $this.removeClass('has-value');
    }
    if ($(this).hasClass('is-invalid') && $(this).val().length > 3) {
        $(this).removeClass('is-invalid');
    }
});
